<template>
	<div style="width: 100%;">
		<!-- PC -->
		<div v-if="ifPc == 1">
			<div
				style="margin: 100px 60px 100px 60px;font-weight: bold;font-size: 80px;height: 94px;line-height: 94px;">
				About Joblogic-X
			</div>
			<div style="display: flex;margin: 0px 60px;">
				<div style="width: 600px;height: 600px;">
					<div style="margin:0px 60px 0px 0px;">
						<div style="font-size: 20px;line-height: 30px;">
							Formed as a Texas corporation in 2015, Joblogic-X is a fast-growing services company
							specializing in marketing solutions, import and export services, as well as staffing,
							consulting, and support.
						</div>
						<div style="font-size: 20px;line-height: 30px;margin-top: 35px;">
							Headquartered in Dallas, TX, Joblogic-X has offices in Dallas, Houston, New York, and
							Beijing, along with a global support center in Qingdao, China.
						</div>
						<div style="font-size: 20px;line-height: 30px;margin-top: 35px;">
							Through a bespoke engagement model, Joblogic-X delivers transformational value to clients
							across a wide range of industries.
						</div>

					</div>
				</div>
				<div style="flex: 1;height: 600px;">
					<el-image src="/newImage/aboutus.png" style="height: 600px;width: 100%;" fit="cover">
					</el-image>
				</div>
			</div>

			<div style="text-align: center;">
				<div style="font-size: 50px;font-weight: bold;margin-top: 100px;">
					OUR CUSTOMERS
				</div>
				<div style="font-size: 20px;margin-top: 12px;">
					Joblogic-X empowers some of the world's top organizations.
				</div>
			</div>

			<div
				style="display: flex;flex-wrap: wrap;align-items: center;gap: 50px 100px;margin:80px 100px 120px 100px;">
				<el-image :src="item" v-for="item in companyList" fit="cover">
				</el-image>
			</div>

			<div style="margin: 120px 60px 120px 60px;">
				<div style="font-size: 50px;font-weight: bold;margin-top: 150px;">
					Corporate Social Responsibility
				</div>
				<div style="font-size: 30px;margin-top: 50px;line-height: 50px;">
					Amazing things happen when our country’s servicemen and women apply the values they’ve developed in
					the military to a rewarding career path as a civilian. Joblogic-X seeks to support veterans through
					their transition from the military into the civilian workforce by recruiting former military
					servicemen and women at every level of our organization. Once a hire has been made, Joblogic-X works
					alongside Workforce Opportunity Services to continue to support a smooth transition.
				</div>
			</div>

			<div style="height: 840px;position: relative;">
				<el-image src="../../newImage/aboutusbottom.png" style="height: 100%;width: 100%;z-index:5;"
					fit="cover">
				</el-image>
				<div style="color: white;z-index: 10;position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;">
					<div style="display: flex;align-items: center;height: 100%;width: 100%;">
						<div style="display: block;margin-left:60px;margin-right: 60px;">
							<div style="font-size: 50px;font-weight: bold;">
								About Workforce Opportunity Services
							</div>
							<div style="font-size: 30px;margin-top: 50px;line-height: 50px;">
								Workforce opportunity Services (WOS) is a 501(c)(3) nonprofit that recruits underserved
								young adults and veterans for professional careers through various skill-based education
								and mentoring programs. Based on the needs of its corporate partners, WOS recruits
								talent and places them as WOS employed consultants.
							</div>
						</div>
					</div>

				</div>
			</div>


		</div>

		<!-- 手机 -->
		<div v-if="ifPc == 2">
			<div
				style="margin: 20px 14px;font-weight: bold;font-size: 18px;height:21px;line-height: 21px;">
				About Joblogic-X
			</div>
			<div style="display: flex;margin: 0px 15px;">
				<div style="width: 175px;height: 150px;">
					<div style="margin:0px 5px 0px 0px;">
						<div style="font-size: 8px;line-height: 10px;">
							Formed as a Texas corporation in 2015, Joblogic-X is a fast-growing services company
							specializing in marketing solutions, import and export services, as well as staffing,
							consulting, and support.
						</div>
						<div style="font-size: 8px;line-height: 10px;margin-top: 10px;">
							Headquartered in Dallas, TX, Joblogic-X has offices in Dallas, Houston, New York, and
							Beijing, along with a global support center in Qingdao, China.
						</div>
						<div style="font-size: 8px;line-height: 10px;margin-top: 10px;">
							Through a bespoke engagement model, Joblogic-X delivers transformational value to clients
							across a wide range of industries.
						</div>

					</div>
				</div>
				<div style="flex: 1;height: 150px;">
					<el-image src="/newImage/aboutus.png" style="height: 100%;width: 100%;" fit="cover">
					</el-image>
				</div>
			</div>

			<div style="text-align: center;">
				<div style="font-size: 24px;font-weight: bold;margin-top: 24px;">
					OUR CUSTOMERS
				</div>
				<div style="font-size: 8px;margin-top: 2px;">
					Joblogic-X empowers some of the world's top organizations.
				</div>
			</div>

			<div style="margin:15px 22px 15px 22px;">
				<el-image src="../../newImage/company/phoneCompany.png" fit="cover" style="width: 100%;">
				</el-image>
			</div>

			<div style="margin: 40px 14px">
				<div style="font-size: 16px;font-weight: bold;">
					Corporate Social Responsibility
				</div>
				<div style="font-size: 8px;margin-top: 14px;line-height: 11.5px;">
					Amazing things happen when our country’s servicemen and women apply the values they’ve developed in
					the military to a rewarding career path as a civilian. Joblogic-X seeks to support veterans through
					their transition from the military into the civilian workforce by recruiting former military
					servicemen and women at every level of our organization. Once a hire has been made, Joblogic-X works
					alongside Workforce Opportunity Services to continue to support a smooth transition.
				</div>
			</div>

			<div style="height: 190px;position: relative;">
				<el-image src="../../newImage/aboutusbottom.png" style="height: 100%;width: 100%;z-index:5;"
					fit="cover">
				</el-image>
				<div style="color: white;z-index: 10;position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;">
					<div style="display: flex;align-items: center;height: 100%;width: 100%;">
						<div style="display: block;margin-left:14px;margin-right: 14px;">
							<div style="font-size: 16px;font-weight: bold;">
								About Workforce Opportunity Services
							</div>
							<div style="font-size: 8px;margin-top: 14px;line-height: 11.5px;">
								Workforce opportunity Services (WOS) is a 501(c)(3) nonprofit that recruits underserved
								young adults and veterans for professional careers through various skill-based education
								and mentoring programs. Based on the needs of its corporate partners, WOS recruits
								talent and places them as WOS employed consultants.
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import utils from "../utils/index.js";
	export default {
		name: "App",
		data() {
			return {
				innerHeight: window.innerHeight,
				ifPc: window.innerWidth > window.innerHeight ? 1 : 2, // 默认根据宽高判断 1PC 2手机
				companyList: [
					"/newImage/company/company1.png",
					"/newImage/company/company2.png",
					"/newImage/company/company3.png",
					"/newImage/company/company4.png",
					"/newImage/company/company5.png",
					"/newImage/company/company6.png",
					"/newImage/company/company7.png",
					"/newImage/company/company8.png",
					"/newImage/company/company9.png",
					"/newImage/company/company10.png",
					"/newImage/company/company11.png",
					"/newImage/company/company12.png",
					"/newImage/company/company13.png",
					"/newImage/company/company14.png",
					"/newImage/company/company15.png",
				],
			};
		},
		computed: {},
		methods: {
			changePage(page) {
				this.$router.push(page);
			}
		},
		mounted() {}
	};
</script>

<style lang="less">
</style>